import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Link } from 'react-router-dom';
import { Input } from 'reactstrap';
import { BaseCustomButton, BaseSelectComponent } from '../../shared';
import { getLabRequestCalendars, getLabs, getRegions } from '../../store/actions';

export const ScheduledTestsSearchersCitec = ({ activeTab }) => {

    const [searchValue, setSearchValue] = useState('');

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [valRequestFolio, setValRequestFolio] = useState('');
    const [valLab, setValLab] = useState('');
    const [valProcess, setValProcess] = useState('');
    const [valRegion, setValRegion] = useState('');

    const [showNomenclature, setShowNomenclature] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        // TODO: Aqui falta filtrar por status "activo"
        if (activeTab === '1') {
            dispatch(getLabs(`?limit=1000&page=0&search=${'citec'}`)); // TODO: ¿Ésta petición de "limit=1000" si es correcta?
            dispatch(getRegions("?limit=100000&page=0"));
            dispatch(getLabRequestCalendars(`?limit=100000&page=0&laboratoryType=${'citec'}&initialDatedAt=&finalDatedAt=`));
        }
    }, [activeTab, dispatch])

    const { labs, regions } = useSelector(state => ({
        labs: state.labsReducer.labs,
        regions: state.regions.regions,
    }), shallowEqual);

    const onHandleSearch = () => {

        if (searchValue === '') {
            dispatch(getLabRequestCalendars(`?limit=100000&page=0&laboratoryType=${'citec'}&initialDatedAt=${startDate}&finalDatedAt=${endDate}`));
        } else if (searchValue === '1') {
            dispatch(getLabRequestCalendars(`?limit=100000&page=0&laboratoryType=${'citec'}&initialDatedAt=${startDate}&finalDatedAt=${endDate}&code=${valRequestFolio}`));
        } else if (searchValue === '2') {
            if (valLab === '' && valProcess === '' && valRegion === '') {
                dispatch(getLabRequestCalendars(`?limit=100000&page=0&laboratoryType=${'citec'}&initialDatedAt=${startDate}&finalDatedAt=${endDate}`));
            }
            if (valLab === '' && valProcess === '' && valRegion !== '') {
                dispatch(getLabRequestCalendars(`?limit=100000&page=0&laboratoryType=${'citec'}&initialDatedAt=${startDate}&finalDatedAt=${endDate}&region=${valRegion}`));
            }
            if (valLab === '' && valProcess !== '' && valRegion === '') {
                dispatch(getLabRequestCalendars(`?limit=100000&page=0&laboratoryType=${'citec'}&initialDatedAt=${startDate}&finalDatedAt=${endDate}&calendaredKey=${valProcess}`));
            }
            if (valLab === '' && valProcess !== '' && valRegion !== '') {
                dispatch(getLabRequestCalendars(`?limit=100000&page=0&laboratoryType=${'citec'}&initialDatedAt=${startDate}&finalDatedAt=${endDate}&calendaredKey=${valProcess}&region=${valRegion}`));
            }
            if (valLab !== '' && valProcess === '' && valRegion === '') {
                dispatch(getLabRequestCalendars(`?limit=100000&page=0&laboratoryType=${'citec'}&initialDatedAt=${startDate}&finalDatedAt=${endDate}&laboratory=${valLab}`));
            }
            if (valLab !== '' && valProcess === '' && valRegion !== '') {
                dispatch(getLabRequestCalendars(`?limit=100000&page=0&laboratoryType=${'citec'}&initialDatedAt=${startDate}&finalDatedAt=${endDate}&laboratory=${valLab}&region=${valRegion}`));
            }
            if (valLab !== '' && valProcess !== '' && valRegion === '') {
                dispatch(getLabRequestCalendars(`?limit=100000&page=0&laboratoryType=${'citec'}&initialDatedAt=${startDate}&finalDatedAt=${endDate}&laboratory=${valLab}&calendaredKey=${valProcess}`));
            }
            if (valLab !== '' && valProcess !== '' && valRegion !== '') {
                dispatch(getLabRequestCalendars(`?limit=100000&page=0&laboratoryType=${'citec'}&initialDatedAt=${startDate}&finalDatedAt=${endDate}&laboratory=${valLab}&calendaredKey=${valProcess}&region=${valRegion}`));
            }

        }

    }



    const nomenclatureToggle = () => {
        setShowNomenclature(!showNomenclature);
    }

    return (
        <>
            <div className="page-title-box d-flex align-items-end justify-content-between px-3 w-100">
            <div className="w-25 me-3">
                <label htmlFor="exampleInputEmail1" className="text-primary ml-1 rounded-3">
                Tipo de Búsqueda
                </label>

                <BaseSelectComponent
                placeholder="Seleccione el tipo de búsqueda"
                options={[
                    { value: '', label: 'Seleccione el tipo de búsqueda...' },
                    { value: '1', label: 'Folio de solicitud' },
                    { value: '2', label: 'Información del Servicio' },
                ]}
                value={
                    searchValue
                    ? {
                        value: searchValue,
                        label:
                            searchValue === '1'
                            ? 'Folio de solicitud'
                            : searchValue === '2'
                            ? 'Información del Servicio'
                            : 'Seleccione el tipo de búsqueda...',
                        }
                    : null
                }
                onChangeAsObject={true}
                onChange={(selectedOption) => {
                    setSearchValue(selectedOption?.value || '');
                }}
                />
            </div>

            <div className="w-25 me-3">
                <label className="text-primary">Fecha Inicio</label>
                <Input
                name="datetime1"
                className="form-control rounded-3 text-primary"
                type="date"
                onChange={(e) => setStartDate(e.target.value)}
                />
            </div>

            <div className="w-25 me-3">
                <label className="text-primary">Fecha Fin</label>
                <Input
                name="datetime2"
                className="form-control rounded-3 text-primary"
                type="date"
                onChange={(e) => setEndDate(e.target.value)}
                />
            </div>

            <div className="w-25 me-3">
                <BaseCustomButton
                    color="dark"
                    className="rounded-3 py-2 w-100"
                    icon="mdi-magnify"
                    label="Buscar"
                    onClick={onHandleSearch}
                />
            </div>
            </div>

            {searchValue === '1' && (
            <div className="px-3 pb-4 me-3">
                <label className="text-primary">Folio de Solicitud</label>
                <input
                type="search"
                className="form-control text-primary rounded-3"
                placeholder="Digita folio de solicitud"
                onChange={(e) => setValRequestFolio(e.target.value)}
                />
            </div>
            )}

            {searchValue === '2' && (
            <div className="row px-3 mb-4">
                <div className="col-4 col-md-4">
                <label htmlFor="exampleInputEmail1" className="text-primary">
                    Laboratorio
                </label>
                <BaseSelectComponent
                    placeholder="Seleccione un Laboratorio"
                    options={labs.map((dir) => ({
                    value: dir.id,
                    label: dir.name,
                    }))}
                    value={
                    valLab
                        ? {
                            value: valLab,
                            label: labs.find((lab) => lab.id === valLab)?.name ?? '',
                        }
                        : null
                    }
                    onChangeAsObject={true}
                    onChange={(selectedOption) => {
                    setValLab(selectedOption?.value || '');
                    }}
                />
                </div>

                <div className="col-4 col-md-4">
                <label htmlFor="exampleInputEmail1" className="text-primary">
                    Proceso
                </label>
                <BaseSelectComponent
                    placeholder="Seleccione un proceso"
                    options={[
                    { value: '', label: 'Seleccione un proceso' },
                    { value: 'Inicio de trabajos', label: 'Inicio de trabajos' },
                    { value: 'Informe parcial', label: 'Informe parcial' },
                    { value: 'Informe final programado', label: 'Informe final programado' },
                    ]}
                    value={
                    valProcess
                        ? { value: valProcess, label: valProcess }
                        : null
                    }
                    onChangeAsObject={true}
                    onChange={(selectedOption) => {
                    setValProcess(selectedOption?.value || '');
                    }}
                />
                </div>

                <div className="col-4 col-md-4">
                <label htmlFor="exampleInputEmail1" className="text-primary">
                    Región
                </label>
                <BaseSelectComponent
                    placeholder="Seleccione una región"
                    options={regions.map((dir) => ({
                    value: dir.id,
                    label: `${dir.state}, ${dir.municipality}`,
                    }))}
                    value={
                    valRegion
                        ? {
                            value: valRegion,
                            label:
                            regions.find((r) => r.id === valRegion)?.state +
                            ', ' +
                            regions.find((r) => r.id === valRegion)?.municipality,
                        }
                        : null
                    }
                    onChangeAsObject={true}
                    onChange={(selectedOption) => {
                    setValRegion(selectedOption?.value || '');
                    }}
                />
                </div>
            </div>
            )}

            <div className="d-flex justify-content-end px-3 me-3 mt-0">
            {showNomenclature && (
                <div className="text-primary d-flex align-items-center">
                <div className="me-3">
                    <strong>I - Inicio de Trabajos</strong>
                </div>
                <div className="me-3">
                    <strong>P - Informe Parcial</strong>
                </div>
                <div className="me-3">
                    <strong>F - Informe Final</strong>
                </div>
                </div>
            )}

            <BaseCustomButton
                color="info"
                className="py-1 d-flex align-items-center justify-content-center me-3"
                label="Nomenclatura"
                onClick={nomenclatureToggle}
            />

            <Link to="/labCitec">
            <BaseCustomButton
                color="info"
                className="py-1 d-flex align-items-center justify-content-center"
                icon="mdi-18px mdi-table"
                label="Tabla"
            />
            </Link>

            </div>
        </>
    );
};
